<template>
  <div>
    <draggable class="inner" :list="items" group="order"   
        @start="startDrag()"
        @end="endDrag()"
        :ref="name"
        :id="name">
        <slot></slot>
    </draggable>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
export default {
  name: "Ordering",
  data() {
    return {
      items: this.value
    }
  },
  props: {
    value: Array,
    name: String
  },
  components: {
    draggable,
  },
  watch: {
    value: {
      handler: function (val) {
        this.items = val
      },
      deep: true
    }
  },
  methods: {
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id === doc.dataset.id);
        console.log(item)
        let indexOfItem = this.items.indexOf(item);
        item.index = count;
        vm.$set(vm.items, indexOfItem, item);
        count++;
      });
      this.dragging = false;
    },
  }
};
</script>
